import { StateNode, TLPointerEventInfo } from "tldraw"

export class EraserIdle extends StateNode {
  static override id = "eraser-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("eraser-erasing", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "none", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
